import {
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Toaster,
  useId,
} from '@fluentui/react-components';
import {
  Add20Filled,
  Add20Regular,
  ArrowUpload20Regular,
  bundleIcon,
  DocumentAdd20Regular,
  Sparkle20Regular,
} from '@fluentui/react-icons';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import type { SynthMethod } from '../../SyntheticGen/MethodPickerDialog/MethodPickerDialog.interface.js';
import { MethodPickerDialog } from '../../SyntheticGen/MethodPickerDialog/MethodPickerDialog.js';
import { CreateDatasetDialog } from '../CreateDatasetDialog/CreateDatasetDialog.js';

import type { CreateDatasetMenuProps } from './CreateDatasetMenu.interface.js';

const AddIcon = bundleIcon(Add20Filled, Add20Regular) as React.FC;

export function CreateDatasetMenu({
  onSubmit,
  onCreated,
  autoOpenSynthetic,
}: CreateDatasetMenuProps) {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [methodPickerOpen, setMethodPickerOpen] = useState(false);

  const navigate = useNavigate();

  const toasterId = useId('create-dataset-toaster');

  useEffect(() => {
    if (autoOpenSynthetic) {
      setMethodPickerOpen(true);
    }
  }, [autoOpenSynthetic]);

  const handleGenerateClick = useCallback(() => {
    setMethodPickerOpen(true);
  }, []);

  const handleMethodContinue = useCallback(
    (method: SynthMethod) => {
      setMethodPickerOpen(false);
      if (method === 'kg') {
        void navigate('/datasets/new-synthetic');
      }
    },
    [navigate],
  );

  const handleManualClick = useCallback(() => {
    setCreateDialogOpen(true);
  }, []);

  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton appearance="primary" icon={<AddIcon />}>
            Create Dataset
          </MenuButton>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<ArrowUpload20Regular />}
              disabled
              secondaryContent="Coming soon"
            >
              Upload file
            </MenuItem>
            <MenuItem icon={<Sparkle20Regular />} onClick={handleGenerateClick}>
              Generate synthetic dataset
            </MenuItem>
            <MenuDivider />
            <MenuItem
              icon={<DocumentAdd20Regular />}
              onClick={handleManualClick}
            >
              Create manually
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>

      <CreateDatasetDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        onSubmit={onSubmit}
        onCreated={onCreated}
      />

      <MethodPickerDialog
        open={methodPickerOpen}
        onClose={() => setMethodPickerOpen(false)}
        onContinue={handleMethodContinue}
      />

      <Toaster toasterId={toasterId} position="bottom-end" />
    </>
  );
}
